import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { displayDateOnly, formatNumbers } from '../../Utils';
import { HiPencilAlt } from 'react-icons/hi';
import { Reimbursement } from '../../Models/Reimbursement';

export default function ReimbursementListTable({
  data,
  viewReimbursement,
}: {
  data: Reimbursement[];
  viewReimbursement: (obj: Reimbursement) => void;
}) {
  const columnHelper = createColumnHelper<Reimbursement>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => viewReimbursement(info.row.original)}
          >
            <HiPencilAlt />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.statusName, {
      id: 'statusName',
      header: 'Status',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.totalPrice, {
      id: 'totalPrice',
      header: 'Price',
      cell: (info) => (
        <i>${formatNumbers(info.row.original.totalPrice ?? 0)}</i>
      ),
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.userId, {
      id: 'userId',
      header: 'Name',
      sortingFn: 'alphanumeric',
      cell: (info) => (
        <i>
          {info.row.original.user?.firstName} {info.row.original.user?.lastName}
        </i>
      ),
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.dateOfPurchase, {
      id: 'dateOfPurchase',
      header: 'Purchase Date',
      cell: (info) => (
        <i>
          {displayDateOnly(info.getValue() ? new Date(info.getValue()!) : null)}
        </i>
      ),
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      // sorting: [
      //   {
      //     id: 'name',
      //     desc: false,
      //   },
      // ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
